import {createReducer} from '@reduxjs/toolkit'
import {
  expressCheckout,
  getOrder,
  getOrderTicketsDownloadUrl,
  placeOrder,
  pollOrder,
  updateOrder,
} from '../actions/placed-order'
import {makeReservation} from '../actions/reservation'
import {PlacedOrderState} from '../types/state'

const defaultState: PlacedOrderState = {
  order: undefined,
  loadingTicketsUrl: true,
  orderPageUrl: null,
  chargeToken: null,
  clientStatus: null,
  pollEnded: false,
}

export const placedOrder = createReducer(defaultState, builder => {
  builder
    .addCase(placeOrder.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    })
    .addCase(pollOrder.fulfilled, (state, action) => {
      state.order = action.payload
      state.pollEnded = true
    })
    .addCase(pollOrder.rejected, state => {
      state.pollEnded = true
    })
    .addCase(makeReservation.pending, () => {
      return defaultState
    })
    .addCase(getOrderTicketsDownloadUrl.pending, state => {
      state.loadingTicketsUrl = true
    })
    .addCase(getOrderTicketsDownloadUrl.fulfilled, (state, action) => {
      if (!action.payload) {
        return defaultState
      }
      const {loadingTicketsUrl, downloadTicketsUrl} = action.payload
      state.loadingTicketsUrl = loadingTicketsUrl
      state.downloadTicketsUrl = downloadTicketsUrl
    })
    .addCase(getOrderTicketsDownloadUrl.rejected, () => {
      return defaultState
    })
    .addCase(expressCheckout.fulfilled, (state, action) => {
      state.clientStatus = action.payload.clientStatus
    })
    .addCase(getOrder.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    })
    .addCase(updateOrder.fulfilled, (state, {payload}) => {
      state.order = payload.order
      state.orderPageUrl = payload.orderPageUrl
      state.chargeToken = payload.chargeToken
      state.orderPageUrls = {
        ...payload.orderPageUrls,
        success: payload.orderPageUrls.success || '',
      }
    })
})
